import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
import ApprovalForm from '../../approval-form'

const SignIn = ({ loading, record_type, id, submitAction, errors, tokens }) => (
  <Fragment>
    <Heading>CCMS Onboarding</Heading>
    <ApprovalForm
      resourceIDs={{ record_type, id }}
      loading={loading}
      submitAction={submitAction}
      errors={errors}
      tokens={tokens}
    />
  </Fragment>
)

export default SignIn



// WEBPACK FOOTER //
// ./src/registration/views/index.jsx